export default function (context) {
  context.store.dispatch('auth/initAuth', context)
  context.store.dispatch('user/initUserData', context)
  context.store.dispatch('order/initOrderData', context)
}